import { render, staticRenderFns } from "./FileDragger.vue?vue&type=template&id=1c46e85b"
import script from "./FileDragger.vue?vue&type=script&lang=js"
export * from "./FileDragger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports